<template>
  <div>
    <a-button type="primary" :style="{ margin: '0 0 24px 0' }" @click="add"
      >新增</a-button
    >
    <a-modal v-model="visible" centered title="添加管理员" @ok="handleOk">
<!--      <p>账号</p>-->
<!--      <a-input placeholder="请输入手机号" v-model="form.loginNo"></a-input>-->
      <p>手机号码</p>
      <a-input v-model="form.phone" autocomplete="off"></a-input>
      <p>昵称</p>
      <a-input v-model="form.name" autocomplete="off"></a-input>
      <p>登录密码</p>
      <a-input-password v-model="form.password" autocomplete="new-password"></a-input-password>
      <p>确认密码</p>
      <a-input-password v-model="Pwd" autocomplete="new-password"></a-input-password>
      <p>角色名称</p>
      <a-select
        v-model="form.roleId"
        default-value=""
        style="width: 100%"
        @change="handleChange"
      >
        <a-select-option
          v-for="(item, index) in xiala"
          :key="index"
          :value="item.id"
        >
          {{ item.roleName }}
        </a-select-option>
      </a-select>
      <p>关联周边商家账号</p>
      <a-select
        v-model="form.partnerId"
        placeholder="请选择周边商家账号"
        style="width: 100%"
        @change="handleChange"
      >
        <a-select-option
          v-for="(item, index) in partnerList"
          :key="item.partnerId"
          :value="item.partnerId"
        >
          {{ item.name }}
        </a-select-option>
      </a-select>
      <p>邮箱</p>
      <a-input v-model="form.email" autocomplete="off"></a-input>
    </a-modal>
    <a-modal v-model="visibletwo" centered title="编辑管理员" @ok="handleOktwo">
      <p>手机号码</p>
      <a-input v-model="forms.phone" autocomplete="off"></a-input>
      <p>昵称</p>
      <a-input v-model="forms.name" autocomplete="off"></a-input>
      <p>新密码</p>
      <a-input-password v-model="newLoginPwd" autocomplete="new-password"></a-input-password>
      <p v-if="forms.objId != loginObjId">角色名称</p>
      <a-select
        v-if="forms.objId != loginObjId"
        v-model="forms.roleId"
        default-value=""
        style="width: 100%"
        @change="handleChange"
      >
        <a-select-option
          v-for="(item, index) in xiala"
          :key="index"
          :value="item.id"
        >
          {{ item.roleName }}
        </a-select-option>
      </a-select>
      <p>关联周边商家账号</p>
      <a-select
        v-model="forms.partnerId"
        placeholder="请选择周边商家账号"
        style="width: 100%"
        @change="handleChange2"
      >
        <a-select-option
          v-for="(item, index) in partnerList"
          :key="item.partnerId"
          :value="item.partnerId"
        >
          {{ item.name }}
        </a-select-option>
      </a-select>
      <p>邮箱</p>
      <a-input v-model="forms.email" autocomplete="off"></a-input>
    </a-modal>
    <a-table
      :columns="columns"
      :row-key="(record) => record.orderNo"
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <!-- 商品图片 -->
      <template slot="pic2" slot-scope="text, record">
        <img class="img2" :src="record.goodsRecord[0].goodsImg" alt="" />
      </template>
      <template slot="goodsName" slot-scope="text, record">
        <span>{{ record.goodsRecord[0].goodsName }}</span>
      </template>
      <a-avatar slot="avatar" icon="user" />
      <a-switch slot="memberStatus" default-checked @change="onChange" />
      <template slot="operate" slot-scope="text, operate">
         <a href="javascript:;" @click="edit(operate)">编辑</a>
        <a href="javascript:;" @click="del(operate)" v-if="operate.objId != loginObjId">删除</a>
      </template>
    </a-table>
  </div>
</template>
<script>
import {
  storePermissions,
  storePermissionsXiala,
  storePermissionsAdd,
  storePermissionsEdit,
  storePermissionsDel,
  getstoresData
} from "@/api/storeApi.js";
import { message } from "ant-design-vue";

const columns = [
  {
    title: "管理员编号",
    dataIndex: "objId",
    // sorter: true,
    align: "center",
    scopedSlots: { customRender: "objId" },
  },
  // {
  //   title: "账号",
  //   dataIndex: "phone",
  //   align: "center",
  //   scopedSlots: { customRender: "phone" },
  // },
  {
    title: "昵称",
    dataIndex: "nickName",
    align: "center",
    scopedSlots: { customRender: "nickName" },
  },
  {
    title: "手机号",
    dataIndex: "phone",
    align: "center",
    scopedSlots: { customRender: "phone" },
  },

  {
    title: "邮箱",
    dataIndex: "email",
    // sorter: true,
    align: "center",
    // width: "10%",
    scopedSlots: { customRender: "email" },
  },

  {
    title: "角色名称",
    dataIndex: "roleName",
    // sorter: true,
    align: "center",

    // width: "15%",
    scopedSlots: { customRender: "roleName" },
  },
  {
    title: "操作",
    dataIndex: "operate",
    scopedSlots: { customRender: "operate" },
  },
];

export default {
  data() {
    return {
      partnerList:[],
      data: [],
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        pageSize: 10,
      },
      loading: false,
      columns,
      visible: false,
      visibletwo: false,
      limit: 10,
      page: 1,
      goodsRecord: [],
      Pwd: "",
      form: {
        email: "",
        loginNo: "",
        phone: "",
        password: "",
        name: "",
        roleId: "",
        record: 1,
      },
      forms: {
        // loginNo: "",
        phone: "",
        password: "",
        name: "",
        roleId: "",
        objId: "",
        partnerId: null,  // 初始化 partnerId 字段，确保响应式系统能追踪
      },
      newLoginPwd: "",
      loginObjId: null
    };
  },
  created() {
    this.loginObjId = sessionStorage.getItem("objId");
    console.log('ssssssssssssssss'+this.loginObjId)
  },
  mounted() {
    // this.getUserListDetails();
    this.getData();
    this.getpermissionsListXiala();
    this.getAllPartner();
  },
  props: ["formInline"],
  methods: {
    handleChange2(value){
      console.log('选择的值:', value);

    },
    getAllPartner(){
      getstoresData().then(res => {
        console.log('getAllPartner',res);
        if(res.success){
          this.partnerList = res.data;
          // 确保 partnerId 是统一的类型（转换为字符串）
          if (this.partnerList && this.partnerList.length > 0) {
            // console.log('partnerList 第一条数据的 partnerId:', this.partnerList[0].partnerId, '类型:', typeof this.partnerList[0].partnerId);
          }
        }
      })
    },
    topage(routerpath) {
      this.$router.push(routerpath);
    },
    getpermissionsListXiala() {
      storePermissionsXiala().then((res) => {
        this.xiala = res.data;
      });
    },
    handleTableChange(pagination, filters, sorter) {
      this.loading = true;
      this.pagination.current = pagination.current; //重置当前页
      storePermissions({ limit: 10, page: this.pagination.current }).then(
        (res) => {
          this.data = res.data;
          this.loading = false;
        }
      );
    },
    edit(row) {
      this.newLoginPwd = '';
      this.visibletwo = true;
      this.forms.objId = row.objId;
      this.forms.email = row.email;
      this.forms.roleId = row.roleId;
      this.forms.name = row.nickName;
      this.forms.password = row.password;
      this.forms.phone = row.phone;
      this.forms.loginNo = row.phone;
      // 确保 partnerId 是数字类型，与 option value 类型一致
      this.forms.partnerId = row.partnerId !== null && row.partnerId !== undefined 
        ? Number(row.partnerId) 
        : undefined;
      // 强制触发 Vue 响应式更新
      this.$forceUpdate();
    },
    // 查询
    query() {
      this.loading = true;
      storePermissions(this.formInline).then((res) => {
        this.pagination.total = res.count;
        this.data = res.data;
        this.loading = false;
      });
    },
    del(row) {
      this.loading = true;
      storePermissionsDel(row.phone).then((res) => {
        this.loading = false;
        this.getData();
        message.success(res.info);
      });
    },
    //
    onChange(checked) {
      console.log(`a-switch to ${checked}`);
    },
    //
    add() {
      this.form = {};
      this.form.name = "";
      this.form.password = "";
      this.Pwd = "";
      this.visible = true;
    },
    handleOk() {
      this.visible = false;
      if (this.form.password.trim() === this.Pwd.trim()) {
        storePermissionsAdd(this.form).then((res) => {
          message.success(res.info);
          this.getData();
          this.form = {};
          this.Pwd = "";
        });
      } else {
        message.warning("两次输入的密码不一致");
      }
    },
    handleOktwo() {
      if(this.newLoginPwd != ''){
        this.forms.password = this.newLoginPwd
      }
      this.visibletwo = false;
      storePermissionsEdit(this.forms).then((res) => {
        message.success(res.info);
        this.getData();
      });
    },
    getData() {
      storePermissions({ page: 1, limit: 10 }).then((res) => {
        this.pagination.total = res.count;
        this.data = res.data;
      });
    },
  },
};
</script>
<style scoped>
.img2 {
  width: 100px;
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/views/right/permissionsTwo/permissionsContentTwo.vue